import React from 'react';

import CancelIcon from '@material-ui/icons/Cancel';

import TableHeader from '../../components/Table/TableHeader';

const tabelaColunas = ['Loja', 'Filial', 'Regional', 'Observação', '']

const parceirosLista = ({ participantes}) => {

  return (
    <div className="container">
      <div className="row">
        <div className='col-sm-8'>
          <h3 className='mt40'>Participantes</h3>
        </div>
      </div>

      <div className="row">
        <div className='col-12'>
          <div className="table-responsive">
            <table className="table">
              <TableHeader columns={tabelaColunas} />
              <tbody>
                {
                  (!participantes || participantes.length === 0) &&
                  <tr><td colSpan={tabelaColunas.length}> Sem Registro </td></tr>
                }
                {
                  participantes && participantes.map((item, index) => (
                  <tr key={index}>
                    <td> {item.nomeParceiro} </td>
                    <td> {item.filial} </td>
                    <td> {item.regional} </td>
                    <td> {item.observacao} </td>
                    <td> {item.aviso} </td>
                  </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default parceirosLista;